import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RetornoBlob } from '../@shared/models/mapa-de-carregamento';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class RealtorioRessalvaService {

  constructor(private http: HttpClient) { }

  getAll(req: any): Observable<HttpResponse<any[]>> {    
    return this.http
      .get<any[]>(
        `RelatorioRessalva? 
        ${req.dataInicio ? `&DataInicio=${req.dataInicio}` : ''}
        ${req.dataFim ? `&DataFim=${req.dataFim}` : ''}
        ${this.getArrayParameterUri(req.agenteIds, 'AgenteIds')}
        ${this.getArrayParameterUri(req.regionaisIds, 'RegionaisIds')}
        ${req.paginaAtual ? `&PaginaAtual=${(req.paginaAtual || 0) + 1}` : '&PaginaAtual=1'}
        ${req.itensPorPagina ? `&ItensPorPagina=${req.itensPorPagina}` : '&PaginaAtual=10'}`,
        { observe: 'response' }
      );
  }


  getAllRegionais(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `RelatorioRessalva/Selecionar/Regionais?${req.nome ?`&nome=${req.nome}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : '&paginaAtual=1'}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }

  getAllAgentsIds(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `RelatorioRessalva/Selecionar/Agentes?
        ${this.getArrayParameterUri(req.regionaisIds, 'RegionaisIds')}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }  

  getArrayParameterUri(parameter, name) {
    let finalSubstring = '';
    if (parameter && parameter.length > 0) {
      parameter.forEach(element => {
        finalSubstring += `${element ? `&${name}=${element}` : ''}`
      });
      return finalSubstring;
    }
    return '';
  }

  public exportarExcel(url){
    return this.http.get<RetornoBlob>(`RelatorioRessalva/ExportarExcel?${url}`, httpOptions);
  }

}
